import { Routes } from '@angular/router';
import { coreRoutes } from '@next/core-lib/app';
import { CustomerGuard } from '@next/core-lib/relationships';

import { AdviceComponent } from './advice/advice.component';
import { OverviewComponent } from './overview/overview.component';
import { EnvironmentalImpactReportComponent } from './reports/environmental-impact-report/environmental-impact-report';
import { FertilizationLegalStandardsComponent } from './reports/fertilization-legal-standards/fertilization-legal-standards.component';
import { FertilizationTableReportComponent } from './reports/fertilization-table-report/fertilization-table-report.component';
import { NutrientBalanceReportComponent } from './reports/nutrient-balance-report/nutrient-balance-report.component';
import { OrganicMatterReportComponent } from './reports/organic-matter-report/organic-matter-report.component';
import { PlanetProofReportComponent } from './reports/planet-proof-report/planet-proof-report.component';
import { ReportComponent } from './reports/report/report.component';
import { SkalReportComponent } from './reports/skal-report/skal-report.component';

export const appRoutes: Routes = [
  {
    path: '',
    component: OverviewComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'cropfields/:cropFieldIds',
    component: OverviewComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'cropfields/:cropFieldIds',
    component: AdviceComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'advice/:cropYear/:cropFieldAdviceId/:treatmentType',
    component: AdviceComponent,
    canActivate: [CustomerGuard],
  },
  { path: 'report', redirectTo: 'report/', pathMatch: 'full' },
  {
    path: 'report/:cropFieldAdviceIdsReport/:reportType',
    component: ReportComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'report/:cropFieldAdviceIdsReport/:reportType/:splitCropFields',
    component: ReportComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'table-report',
    redirectTo: 'table-report/',
    pathMatch: 'full',
  },
  {
    path: 'table-report/:cropFieldAdviceIds',
    component: FertilizationTableReportComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'fertilization-legal-standards',
    redirectTo: 'fertilization-legal-standards/',
    pathMatch: 'full',
  },
  {
    path: 'fertilization-legal-standards/',
    component: FertilizationLegalStandardsComponent,
    canActivate: [CustomerGuard],
  },
  { path: 'skal-report', redirectTo: 'skal-report/', pathMatch: 'full' },
  {
    path: 'skal-report/',
    component: SkalReportComponent,
    canActivate: [CustomerGuard],
  },
  { path: 'organic-matter-report', redirectTo: 'organic-matter-report/', pathMatch: 'full' },
  {
    path: 'organic-matter-report/:cropFieldIds',
    component: OrganicMatterReportComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'nutrient-balance-report',
    redirectTo: 'nutrient-balance-report/',
    pathMatch: 'full',
  },
  {
    path: 'nutrient-balance-report/:cropFieldIds',
    component: NutrientBalanceReportComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'environmental-impact-report/:cropFieldIds',
    component: EnvironmentalImpactReportComponent,
    canActivate: [CustomerGuard],
  },
  { path: 'planet-proof', redirectTo: 'planet-proof/', pathMatch: 'full' },
  {
    path: 'planet-proof/:cropFieldIds',
    component: PlanetProofReportComponent,
    canActivate: [CustomerGuard],
  },
  ...coreRoutes,
];
